import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveFollow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollows } from "./useFollows"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateFollow() {
  const saveFollow = useSaveFollow()
  const {
    mutate, data: follows,
  } = useFollows()

  return useMemo(
    () => saveFollow &&
      (async (follow: PartialWithId<Follow>) => {
        try {
          const response = await saveFollow(follow)

          if (follows) {
            const responseFollow = response.data.follow

            const updatedList = follows.map((cachedFollow) => {
              if (cachedFollow.id === responseFollow.id) {
                return responseFollow
              }

              return cachedFollow
            })

            void mutate(updatedList)
          } else {
            void mutate()
          }

          return response
        } catch (e) {
          noticeError(
            e,
            "UpdateFollow",
            { follow },
          )

          throw e
        }
      }),
    [
      saveFollow,
      follows,
      mutate,
    ],
  )
}
